import { render } from "./hrm-leave-policy-modal.vue?vue&type=template&id=797f0fac"
import script from "./hrm-leave-policy-modal.vue?vue&type=script&lang=js"
export * from "./hrm-leave-policy-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__